const feedback = {
  notify: (options) => {
    console.warn("feedback.notify was called before FeedbackProvider was mounted", options);
  },
  confirm: (options) => {
    console.warn("feedback.confirm was called before FeedbackProvider was mounted", options);
    return Promise.resolve(false);
  }
};

export default feedback;